import React, { useEffect } from "react";
import DashboardContainer from "../../components/dashboard-container";
// import { KamanExportComponent } from "@yoctotta/kaman";
// import "@yoctotta/kaman/dist/esm/lib.css";
import * as Chart from "chart.js";
import Chatbot from "@yoctotta/chatbot";
import "@yoctotta/chatbot/dist/chatbot.css";
import { Box, Typography, useTheme } from "@mui/material";
import { kamanService } from "../../utils/services/kamanService";
import config from "../../config";
import { useDarkMode } from "../../components/context/darkModeContext";

const Kaman = ({}) => {
  const [canUpgrade, setCanUpgrade] = React.useState(false);
  const [canAccess, setCanAccess] = React.useState(false);
  const [kamanToken, setKamanToken] = React.useState("");
  const theme = useTheme();
  const defaultColor = "#D13438";
  const primary_color = theme?.palette?.primary?.main || defaultColor;
  const secondary_color = theme?.palette?.secondary?.main || defaultColor;
  const { colors } = useDarkMode();
  const handleSendMessage = async (message, attachments) => {
    console.log("Message sent:", message, attachments);
    // Make API call to your backend
    // const response = await api.sendMessage(message, attachments);
    // return {
    //   content: response.text,
    //   artifact: response.artifact, // Optional
    // };
  };

  useEffect(() => {
    let roles = localStorage.getItem("roles");
    try {
      roles = JSON.parse(roles);
    } catch (error) {
      console.error("Error parsing roles from localStorage:", error);
    }
    if (roles && roles.find((role) => role.name === "Admin")) {
      setCanAccess(true);
    } else if (
      roles &&
      roles.find((role) => ["Client - Standard"].includes(role.name))
    ) {
      setCanAccess(false);
      setCanUpgrade(true);
    } else {
      setCanUpgrade(false);
      setCanAccess(false);
    }
  }, []);

  useEffect(() => {
    const fetchKamanToken = async () => {
      try {
        const response = await kamanService.generateToken();
        if (response && response.token) {
          setKamanToken(response.token);
          setCanAccess(true);
        }
      } catch (error) {
        console.error("Error fetching Kaman token:", error);
      }
    };

    fetchKamanToken();
  }, []);

  return (
    <DashboardContainer
      filterButton={false}
      hideUploadButton
      hideAddButton
      hideFilterClient={true}
      hideAllButton
      hideGridList
    >
      {/* Overlay container with relative positioning */}
      <Box sx={{ position: "relative", width: "100%", height: "100%" }}>
        {/* The actual content behind the overlay */}
        {kamanToken && (
          <Box sx={{ filter: canAccess ? "none" : "blur(2px)" }}>
            <Chatbot
              baseUrl={config.kaman_baseUrl}
              token={kamanToken}
              expertId={config.kaman_expert_copilot.id}
              theme={{
                primaryColor: primary_color, //"#c5c7c9ff",
                secondaryColor: secondary_color, //"#dadce2ff",
                textColor: colors.textPrimary,
                backgroundColor: colors.bgPrimary,
                borderColor: colors.border,
                borderRadius: "8px",
                fontFamily: "Poppins",
                // fontSize: "12px",
              }}
              showAppsSelection={false}
              style={{
                width: "100%",
                height: "calc(100vh - 164px)", // Adjust height based on your layout
                textAlign: "left",
              }}
              expertName={config.kaman_expert_copilot.name}
            />
          </Box>
        )}

        {!canAccess ? (
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(255, 255, 255, 0.8)",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 10,
              opacity: 0.7,
            }}
          >
            <Typography
              variant="h2"
              component="div"
              sx={{
                color: "#222222",
                fontWeight: "bold",
                textShadow: "1px 1px 3px rgba(0,0,0,0.2)",
                letterSpacing: "2px",
                mb: 2,
              }}
            >
              Setting Up AI-Powered Support
            </Typography>
            <Typography
              variant="h6"
              component="div"
              sx={{
                color: "var(--text-tertiary)",
                opacity: 0.8,
                textAlign: "center",
                maxWidth: "600px",
                px: 2,
              }}
            >
              You can now interact with our AI-powered support system. Ask any
              questions or get assistance with your logistics needs. The AI is
              here to help you streamline your operations and provide quick
              responses to your queries.
            </Typography>
          </Box>
        ) : !canAccess && canUpgrade ? (
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(255, 255, 255, 0.8)",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 10,
              opacity: 0.7,
            }}
          >
            <Typography
              variant="h2"
              component="div"
              sx={{
                color: "#222222",
                fontWeight: "bold",
                textShadow: "1px 1px 3px rgba(0,0,0,0.2)",
                letterSpacing: "2px",
                mb: 2,
              }}
            >
              UPGRADE REQUIRED
            </Typography>
            <Typography
              variant="h6"
              component="div"
              sx={{
                color: "var(--text-tertiary)",
                opacity: 0.8,
                textAlign: "center",
                maxWidth: "600px",
                px: 2,
              }}
            >
              Upgrade your current subscription to use the AI-powered
              functionalities.
            </Typography>
          </Box>
        ) : !canAccess && !canUpgrade ? (
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(255, 255, 255, 0.8)",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 10,
              opacity: 0.7,
            }}
          >
            <Typography
              variant="h2"
              component="div"
              sx={{
                color: "#222222",
                fontWeight: "bold",
                textShadow: "1px 1px 3px rgba(0,0,0,0.2)",
                letterSpacing: "2px",
                mb: 2,
              }}
            >
              ACCESS DENIED
            </Typography>
            <Typography
              variant="h6"
              component="div"
              sx={{
                color: "var(--text-tertiary)",
                opacity: 0.8,
                textAlign: "center",
                maxWidth: "600px",
                px: 2,
              }}
            >
              You do not have permission to access this AI-powered feature.
              Please contact your administrator.
            </Typography>
          </Box>
        ) : (
          <></>
        )}
      </Box>
    </DashboardContainer>
  );
};

export default Kaman;
